import type { HTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react';

type Align = 'left' | 'right' | 'center';

// Full class names on purpose: Tailwind only generates classes it can see in the source.
const ALIGN: Record<Align, string> = { left: 'text-left', right: 'text-right', center: 'text-center' };

export function Table({ className = '', ...props }: HTMLAttributes<HTMLTableElement>) {
  return (
    <div className="overflow-x-auto">
      <table {...props} className={`w-full border-collapse whitespace-nowrap text-sm ${className}`} />
    </div>
  );
}

export function Th({
  className = '',
  align = 'right',
  ...props
}: ThHTMLAttributes<HTMLTableCellElement> & { align?: Align }) {
  return (
    <th
      {...props}
      className={`border border-slate-200 bg-slate-50 px-2 py-1.5 font-semibold ${ALIGN[align]} ${className}`}
    />
  );
}

export function Td({
  className = '',
  align = 'right',
  ...props
}: TdHTMLAttributes<HTMLTableCellElement> & { align?: Align }) {
  return <td {...props} className={`border border-slate-200 px-2 py-1.5 tabular-nums ${ALIGN[align]} ${className}`} />;
}
